import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { ListFormationResponse, FormationResponse } from '../Types/Responses/FormationResponses'
import { CreateFormation } from '../Types/Requests/FormationRequests'

/**
 * Formações de pagamento do médico (`/dsPaymentDoctorFormation`).
 *
 * DÉBITO ESTRUTURAL CONHECIDO: `DsPaymentFormationService.ts` é uma cópia byte a
 * byte deste arquivo (mesmo prefixo, mesma classe `FomationService` — typo
 * incluso). Este é o registrado no singleton (`Network.paymentFormation`); o outro
 * é instanciado direto por `doctor.infos.form.vue` e `management.doctor.modal.vue`.
 * A unificação exige mexer nesses consumidores e fica fora do escopo deste PR
 * (só mensagens de erro).
 */
export default class FomationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/dsPaymentDoctorFormation'
  }

  async create(payload: CreateFormation): Promise<FormationResponse> {
    try {
      const { data } = await request.post<FormationResponse>(`${this.getCompletePath()}`, payload)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar a formação de pagamento.')
    }
  }

  async get(): Promise<FormationResponse[]> {
    try {
      const { data } = await request.get<{ data: FormationResponse[] }>(this.getCompletePath())
      return data.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as formações de pagamento.')
    }
  }

  async list(): Promise<ListFormationResponse> {
    try {
      const { data } = await request.get<ListFormationResponse>(`${this.getCompletePath()}`)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as formações de pagamento.')
    }
  }

  async remove(formationId: number): Promise<void> {
    try {
      await request.delete(`${this.getCompletePath()}/${formationId}`)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir a formação de pagamento.')
    }
  }

  async update(shiftId: number, payload: CreateFormation): Promise<FormationResponse> {
    try {
      const { data } = (await request.patch(`${this.getCompletePath()}/${shiftId}`, payload)) as {
        data: FormationResponse
      }
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível salvar as alterações da formação de pagamento.')
    }
  }

  async getByScheduleId(scheduleId: number): Promise<ListFormationResponse> {
    try {
      const { data } = await request.get<ListFormationResponse>(
        `${this.getCompletePath()}/schedule/${scheduleId}`
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as formações de pagamento da escala.')
    }
  }

  async getById(shiftId: number): Promise<FormationResponse> {
    try {
      const { data } = await request.get<FormationResponse>(`${this.getCompletePath()}/${shiftId}`)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os dados da formação de pagamento.')
    }
  }

  async updateBulk(scheduleId: number, payload: FormationResponse[]): Promise<void> {
    try {
      await request.patch(`${this.getCompletePath()}/bulk/schedule/${scheduleId}`, payload)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível salvar as formações de pagamento da escala.')
    }
  }
}
